<template>
  <div>
    <Modal v-model="infoModal" width="1000" footer-hide>
      <div class="private-cloud-resource-detail-content">
        <div class="main" style="padding: 0">
          <div>
            <Row>
              <Col :xs="24" :sm="24" :md="24" :lg="24">
                <div>
                  <Alert v-if="infoError" type="warning" show-icon>获取子网详情数据失败</Alert>
                  <div class="info-property" v-else style="border: none; box-shadow: none;">
                    <dl>
                      <dt>ID</dt><dd>{{ info.id }}</dd>
                    </dl>
                    <dl>
                      <dt>子网名称</dt><dd>{{ info.name }}</dd>
                    </dl>
                    <dl>
                      <dt>网络ID</dt><dd>{{ info.network_id }}</dd>
                    </dl>
                    <dl>
                      <dt>子网池</dt>
                      <dd>{{ info.subnetpool_id }}</dd>
                    </dl>
                    <dl>
                      <dt>IP版本</dt><dd>{{ info.ip_version }}</dd>
                    </dl>
                    <dl>
                      <dt>CIDR</dt><dd>{{ info.cidr }}</dd>
                    </dl>
                    <dl>
                      <dt>网关IP</dt><dd>{{ info.gateway_ip }}</dd>
                    </dl>
                    <dl>
                      <dt>DHCP已启用</dt>
                      <dd v-if="info.enable_dhcp"><span>是</span></dd>
                      <dd v-else><span>否</span></dd>
                    </dl>
                    <dl>
                      <dt>IP地址分配池</dt>
                      <dd>
                        <div v-for="(item, index) in info.allocation_pools" :key="'allocation_pools_' + index">
                          <p><span>开始：{{ item.start }}</span><span> - 结束：{{ item.end }}</span></p>
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>额外路由</dt>
                      <dd>
                        <div v-for="(item, index) in info.host_routes" :key="'host_routes_' + index">
                          <p><span>目的地 {{ item.destination }}</span><span>：下一跳 {{ item.nexthop }}</span></p>
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>DNS服务器</dt>
                      <dd>
                        <div v-for="(item, index) in info.dns_nameservers" :key="'dns_nameservers_' + index">
                          <p><span>{{ item }}</span></p>
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>创建时间</dt><dd v-if="info.created_at">{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                    </dl>
                    <dl>
                      <dt>更新时间</dt><dd v-if="info.updated_at">{{ moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                    </dl>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
import { detailPrivateCloudSubnet } from '@/api/private-cloud/subnet'

export default {
  name: 'subnet-detail',
  data () {
    return {
      infoModal: false,
      infoError: false,
      info: {},
      moment: moment
    }
  },
  methods: {
    getInfo (id) {
      detailPrivateCloudSubnet(id).then(res => {
        this.infoError = false
        this.info = res.data.subnet
        this.infoModal = true
      }).catch(res => {
        this.infoError = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../base.less';
</style>
